import {FontItem} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {RECOMMENDED_FONTS} from '~/common/fabric/CreateDesign/constants';
import {Typography} from '~library/atoms/Typography';
import './RecommendedFonts.sass';

export const RecommendedFonts = ({onChange, selectedFont}) => (
  <div>
    <Typography as="p" variant="paragraph4" size="medium" className="recommended_fonts__title">
      RECOMMENDED FONTS
    </Typography>

    {RECOMMENDED_FONTS.map((font) => (
      <FontItem
        onClick={onChange}
        font={font}
        key={font.family}
        selected={selectedFont?.family === font?.family}
      />
    ))}
  </div>
);
